import { EstateResultItem_OneViewSourceInfoInput } from 'queries';

import Asset from './asset';

type Props = {
  id: string;
  showAssetBtn: boolean;
  source: EstateResultItem_OneViewSourceInfoInput;
  title: string;
};

export default function SourceAsset({ id, showAssetBtn, source, title }: Props) {
  return (
    <Asset
      key={id}
      showAssetBtn={showAssetBtn}
      itemData={[
        { field: 'Name', value: source.sourceName },
        {
          field: 'Address',
          value: `${source.primaryAddress} ${source.secondaryAddress || ''} 
          ${source.cityName}, ${source.stateAbbreviation} ${source.zipCode}`,
        },
        { field: 'Telephone Number', value: source.telephoneNumber },
      ]}
      title={title}
    />
  );
}
